
import { Ball, SimulationConfig } from '@/types';
import { SpawnerPhysics } from '../modes/SpawnerPhysics';

export const SpawnerLogic = {
  update: (
      deltaTime: number,
      config: SimulationConfig,
      balls: Ball[],
      now: number,
      createBall: (overrides: Partial<Ball>) => Ball,
      onBallAdded: (count: number) => void
  ) => {
      if (!config.enableSpawner && config.mode !== 'SPAWNER') return;

      // 1. Lifecycle management
      const filteredBalls = SpawnerPhysics.updateLifecycle(balls, config, now, deltaTime);
      if (filteredBalls.length !== balls.length) {
          balls.length = 0;
          balls.push(...filteredBalls);
          onBallAdded(balls.length);
      }

      // 2. Emitter Logic
      if (config.spawnerEngineMode === 'EMITTER' && balls.length < config.maxBalls) {
          const lastEmit = (window as any).lastSpawnerEmitTime || 0;
          const interval = config.spawnerSpawnInterval || 1000;

          if (now - lastEmit > interval) {
              (window as any).lastSpawnerEmitTime = now;
              const nb = createBall({
                  id: `emit-${now}`,
                  pos: { x: 0, y: 0 },
                  vel: SpawnerPhysics.getSpawnVelocity(config),
                  spawnTime: now
              });
              balls.push(nb);
              onBallAdded(balls.length);
          }
      }
  }
};
